import styled from 'styled-components'

export const Title = styled.h1`
  font-family: Mulish;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-tertiary);
  margin-top: 1em;
`

export const Description = styled.h3`
  font-family: Mulish;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  color: var(--text-tertiary);
  margin-top: 1.7em;
`

// export const Content = styled.div`
//   margin-top: 32px;
//   display: flex;
//   flex-direction: column;
//   gap: 26px;

//   header,
//   main {
//     display: flex;
//     flex-direction: column;
//     gap: 1rem;

//     ul {
//       display: grid;
//       grid-template-columns: 15% 16% 18% 10% 10% 6% 13%;
//       color: var(--text-tertiary);
//       gap: 2%;

//       li {
//         display: flex;
//         align-items: center;
//         gap: 10px;
//         overflow-wrap: anywhere;

//         svg {
//           cursor: pointer;
//         }

//         :nth-child(n + 4):nth-child(-n + 6) {
//           justify-content: center;
//           text-align: center;
//         }
//       }

//       @media (max-width: 992px) {
//         grid-template-columns: 1fr;
//         grid-template-rows: repeat(auto-fit, 100px);

//         li {
//           justify-content: center;
//           text-align: center;
//           align-items: center;
//         }
//       }
//     }
//   }

//   header ul li {
//     font-size: var(--font-size-sm);
//     font-weight: bold;
//   }

//   main ul li {
//     font-size: var(--font-size-sm);
//   }

//   footer {
//     width: 100%;
//     display: flex;
//     justify-content: center;
//     gap: 1rem;
//   }
// `
